import React from 'react';
import Hero from '@/components/sections/Hero';
import ExploreServices from '@/components/sections/ExploreServices';
import Industries from '@/components/sections/Industries';
import Achievements from '@/components/sections/Achievements';
import Portfolio from '@/components/sections/Portfolio';
import CaseStudy from '@/components/sections/CaseStudy';
import OurValues from '@/components/sections/OurValues';
import Technologies from '@/components/sections/Technologies';
import Testimonials from '@/components/sections/Testimonials';
import EsteemedClients from '@/components/sections/EsteemedClients';
import CtaBand from '@/components/sections/CtaBand';
import { useHomeData } from '@/hooks/useHomeData';

export default function Home() {
  const { data } = useHomeData();

  // While loading or on error, every prop is `undefined` and each section
  // component renders nothing until the live data arrives.
  const sections = data?.sections || {};
  const collections = data?.collections || {};

  return (
    <>
      {(!data || sections.hero) && <Hero data={sections.hero?.data} />}
      {(!data || sections.servicesHeader) && <ExploreServices data={sections.servicesHeader?.data} items={collections.services} />}
      {(!data || sections.industriesHeader) && <Industries data={sections.industriesHeader?.data} items={collections.industries} />}
      {(!data || sections.achievements) && <Achievements data={sections.achievements?.data} />}
      {(!data || sections.portfolioHeader) && <Portfolio
        data={sections.portfolioHeader?.data}
        items={collections.portfolioItems}
        categories={collections.portfolioCategories}
      />}
      {(!data || sections.caseStudyHome) && <CaseStudy data={sections.caseStudyHome?.data} items={collections.caseStudies} />}
      {(!data || sections.valuesHeader) && <OurValues data={sections.valuesHeader?.data} items={collections.valuesItems} />}
      {(!data || sections.techHeader) && <Technologies data={sections.techHeader?.data} items={collections.technologies} />}
      {(!data || sections.testimonialsHeader) && <Testimonials data={sections.testimonialsHeader?.data} items={collections.testimonials} />}
      {(!data || sections.clientsHeader) && <EsteemedClients data={sections.clientsHeader?.data} items={collections.clients} />}
      {(!data || sections.ctaBand) && <CtaBand data={sections.ctaBand?.data} />}
    </>
  );
}
